export default {
  "config": {
    "trial": "tones-3",
    "id": "study-design",
    "type": "design",
    "title": "Study Design for the Phase 3, 12-Week, Double-Blind, Randomized, Placebo-Controlled, Parallel-Group Study<sup>30</sup>",
    "footnotes": [
      "The maximum recommended dose for solriamfetol in the USA PI is 150 mg.<sup>27</sup>",
      "Numbers indicate safety population."
    ],
    "useFootnoteTooltip": true
  },
  "data": {
    "trial": "tones-3",
    "id": "study-design",
    "data-type": "design",
    "title": "Study Design for the Phase 3, 12-Week, Double-Blind, Randomized, Placebo-Controlled, Parallel-Group Study<sup>30</sup>",
    "footnote-tooltip": "enable",
    "footnote-order": [
      "footnote-note1",
      "footnote-note2"
    ],
    "footnote-note1": "The maximum recommended dose for solriamfetol in the USA PI is 150 mg.<sup>27</sup>",
    "footnote-note2": "Numbers indicate safety population."
  }
};